import React, { useEffect, useState } from 'react';

import { Loader, Select, SelectProps, useMantineTheme } from '@mantine/core';
import { SelectItem } from '@mantine/core/lib/Select/types';
import usePayRates from 'hooks/payRate/usePayRates';
import { PayRate } from 'types';

interface IPayRateSelectProps extends Omit<SelectProps, 'data' | 'rightSection'> {
  payRateTypes?: PayRate['payRateType'][];
  cyData?: string;
}

const PayRateSelect = ({ payRateTypes, cyData, ...selectProps }: IPayRateSelectProps): JSX.Element => {
  const theme = useMantineTheme();
  const [options, setOptions] = useState<SelectItem[]>([]);
  const { data, isSuccess, isLoading } = usePayRates({
    limit: '10000',
    payRateTypes,
  });
  useEffect(() => {
    if (isSuccess && data) {
      const payRates = data.pages
        .map(page => page.data.results)
        .flat()
        .map(payRate => {
          return {
            ...payRate,
            value: payRate.payRateId,
            label: payRate.name,
          };
        });
      setOptions(payRates);
    }
  }, [data, isSuccess]);

  return (
    <Select
      data-cy={cyData}
      {...selectProps}
      data={options}
      searchable
      nothingFound='Pay Rates Not Found'
      maxDropdownHeight={100}
      rightSection={isLoading ? <Loader size={theme.fontSizes.md} /> : undefined}
      clearable
    />
  );
};

export default PayRateSelect;
